module.exports = "<svg viewBox=\"0 0 81.1 110.1\"><path d=\"M0 10h81.1\" class=\"st0\"></path><path d=\"M0 55.1h81.1\" class=\"st0\"></path><path d=\"M0 100.1h81.1\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/burger.svg
// module id = 275
// module chunks = 1